import { LayaGL } from "../../../layagl/LayaGL";
import { Vector4 } from "../../../maths/Vector4";
import { ShaderDataType } from "../../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { RenderState } from "../../../RenderDriver/RenderModuleData/Design/RenderState";
import { BufferUsage } from "../../../RenderEngine/RenderEnum/BufferTargetType";
import { DrawType } from "../../../RenderEngine/RenderEnum/DrawType";
import { MeshTopology } from "../../../RenderEngine/RenderEnum/RenderPologyMode";
import { Shader3D, ShaderFeatureType } from "../../../RenderEngine/RenderShader/Shader3D";
import { SubShader } from "../../../RenderEngine/RenderShader/SubShader";
import { VertexDeclaration } from "../../../RenderEngine/VertexDeclaration";
import { VertexElement } from "../../../renders/VertexElement";
import { VertexElementFormat } from "../../../renders/VertexElementFormat";
import { Texture2D } from "../../../resource/Texture2D";
import { Pool } from "../../../utils/Pool";
import { Command2D } from "./Command2D";
export class Blit2DCMD extends Command2D {
    static __initBlitShader__() {
        let blitvs = `
        #define SHADER_NAME Blit2DVS

        varying vec2 v_Texcoord0;

        void main()
        {
            gl_Position = vec4(u_OffsetScale.x * 2.0 - 1.0 + (a_PositionTexcoord.x + 1.0) * u_OffsetScale.z, (1.0 - ((u_OffsetScale.y * 2.0 - 1.0 + (-a_PositionTexcoord.y + 1.0) * u_OffsetScale.w) + 1.0) / 2.0) * 2.0 - 1.0, 0.0, 1.0);

            v_Texcoord0 = a_PositionTexcoord.zw;

            #ifdef INVERTY
            gl_Position.y = -gl_Position.y;
            #endif
        }
        `;
        let blitfs = `
        #define SHADER_NAME Blit2DFS

        #include "Color.glsl";

        varying vec2 v_Texcoord0;

        void main()
        {
            vec4 mainColor = texture2D(u_MainTex, v_Texcoord0);
            #ifdef Gamma_u_MainTex
            mainColor = gammaToLinear(mainColor);
            #endif // Gamma_u_AlbedoTexture
            gl_FragColor = mainColor;
            gl_FragColor = outputTransform(gl_FragColor);
        }
        `;
        let attributeMap = {
            "a_PositionTexcoord": [0, ShaderDataType.Vector4]
        };
        let uniformMap = {
            "u_OffsetScale": ShaderDataType.Vector4,
            "u_MainTex": ShaderDataType.Texture2D,
            "u_MainTex_TexelSize": ShaderDataType.Vector4,
        };
        let shader = Shader3D.add("Blit2DCMD");
        shader.shaderType = ShaderFeatureType.PostProcess;
        let subShader = new SubShader(attributeMap, uniformMap);
        shader.addSubShader(subShader);
        let blitPass = subShader.addShaderPass(blitvs, blitfs);
        blitPass.statefirst = true;
        blitPass.renderState.depthWrite = false;
        blitPass.renderState.depthTest = RenderState.DEPTHTEST_OFF;
        blitPass.renderState.blend = RenderState.BLEND_ENABLE_ALL;
        blitPass.renderState.blendEquation = RenderState.BLENDEQUATION_ADD;
        blitPass.renderState.srcBlend = RenderState.BLENDPARAM_ONE;
        blitPass.renderState.dstBlend = RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA;
        blitPass.renderState.cull = RenderState.CULL_NONE;
    }
    static __initGeometryElement__() {
        let _vertices = new Float32Array([
            1, 1, 1, 1,
            1, -1, 1, 0,
            -1, 1, 0, 1,
            -1, -1, 0, 0
        ]);
        let vertexDec = new VertexDeclaration(16, [new VertexElement(0, VertexElementFormat.Vector4, 0)]);
        let vertex = LayaGL.renderDeviceFactory.createVertexBuffer(BufferUsage.Dynamic);
        vertex.vertexDeclaration = vertexDec;
        vertex.setDataLength(_vertices.buffer.byteLength);
        vertex.setData(_vertices.buffer, 0, 0, _vertices.buffer.byteLength);
        let bufferState = LayaGL.renderDeviceFactory.createBufferState();
        bufferState.applyState([vertex], null);
        let geometry = Blit2DCMD.QuadGeometry = LayaGL.renderDeviceFactory.createRenderGeometryElement(MeshTopology.TriangleStrip, DrawType.DrawArray);
        geometry.setDrawArrayParams(0, 4);
        geometry.bufferState = bufferState;
        Blit2DCMD.__initInvertGeometryElement__();
    }
    static __initInvertGeometryElement__() {
        let _vertices = new Float32Array([
            1, 1, 1, 0,
            1, -1, 1, 1,
            -1, 1, 0, 0,
            -1, -1, 0, 1
        ]);
        let vertexDec = new VertexDeclaration(16, [new VertexElement(0, VertexElementFormat.Vector4, 0)]);
        let vertex = LayaGL.renderDeviceFactory.createVertexBuffer(BufferUsage.Dynamic);
        vertex.vertexDeclaration = vertexDec;
        vertex.setDataLength(_vertices.buffer.byteLength);
        vertex.setData(_vertices.buffer, 0, 0, _vertices.buffer.byteLength);
        let bufferState = LayaGL.renderDeviceFactory.createBufferState();
        bufferState.applyState([vertex], null);
        let geometry = Blit2DCMD.InvertQuadGeometry = LayaGL.renderDeviceFactory.createRenderGeometryElement(MeshTopology.TriangleStrip, DrawType.DrawArray);
        geometry.setDrawArrayParams(0, 4);
        geometry.bufferState = bufferState;
    }
    static __init__() {
        Blit2DCMD.__initBlitShader__();
        Blit2DCMD.__initGeometryElement__();
        Blit2DCMD._blitShaderData = LayaGL.renderDeviceFactory.createShaderData();
        Blit2DCMD._defaultShader = Shader3D.find("Blit2DCMD");
    }
    static create(source, dest, offsetScale = null, shader = null, shaderData = null) {
        if (!Blit2DCMD._blitShaderData)
            Blit2DCMD.__init__();
        let cmd = Blit2DCMD._pool.take();
        cmd.source = source;
        cmd.dest = dest;
        cmd.offsetScale = offsetScale;
        cmd.setshader(shader, shaderData);
        return cmd;
    }
    constructor() {
        super();
        this._source = null;
        this._dest = null;
        this._offsetScale = new Vector4();
        this._shader = null;
        this._shaderData = null;
        this._renderElement = LayaGL.render2DRenderPassFactory.createRenderElement2D();
        this._blitQuadCMDData = LayaGL.render2DRenderPassFactory.createBlit2DQuadCMDData();
        this._blitQuadCMDData.element = this._renderElement;
        this._renderElement.geometry = Blit2DCMD.QuadGeometry;
        this._renderElement.nodeCommonMap = null;
        this._renderElement.renderStateIsBySprite = false;
    }
    get offsetScale() {
        return this._offsetScale;
    }
    set offsetScale(value) {
        value ? value.cloneTo(this._offsetScale) : Blit2DCMD._defaultOffsetScale.cloneTo(this._offsetScale);
        this._blitQuadCMDData.offsetScale = this._offsetScale;
    }
    get source() {
        return this._source;
    }
    set source(value) {
        this._source = value;
        this._blitQuadCMDData.source = value ? value._texture : Texture2D.blackTexture._texture;
    }
    get dest() {
        return this._dest;
    }
    set dest(value) {
        this._dest = value;
        this._blitQuadCMDData.dest = value ? value._renderTarget : null;
    }
    set shaderData(value) {
        this._shaderData = value || Blit2DCMD._blitShaderData;
        this._renderElement.materialShaderData = this._shaderData;
    }
    getRenderCMD() {
        return this._blitQuadCMDData;
    }
    setshader(shader, shaderData) {
        this._shader = shader || Blit2DCMD._defaultShader;
        this.shaderData = shaderData;
        this._renderElement.subShader = this._shader.getSubShaderAt(0);
    }
    destroy() {
        this._commandBuffer = null;
        this._context = null;
    }
    recover() {
        super.recover();
        Blit2DCMD._pool.recover(this);
    }
}
Blit2DCMD._defaultOffsetScale = new Vector4(0, 0, 1, 1);
Blit2DCMD._pool = Pool.createPool(Blit2DCMD);
